module.exports = __webpack_public_path__ + "img/Mickies_Pizzeria@1x.31c9d38b.webp";